import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

import BuyDownOptionsTable from "./BuyDownOptionsTable";

import "./BuyDownOptionsWrapper.css";

export default function BuyDownOptions(props: any) {
  const { t } = useTranslation();

  return (
    <Grid container className="buy-down-container">
      <Grid item xs={12} m={2} style={{ margin: "12px" }}>
        <span className="buy-down-header">{props.header}</span>
      </Grid>
      <Grid item xs={12} m={2} style={{ margin: "12px 12px 0px 12px" }}>
        <BuyDownOptionsTable
          tableHeader={props?.tableHeader}
          tableBody={props?.tableBody}
          handleInterestChange={props?.handleInterestChange}
          currentSelectedInterestRate={props?.currentSelectedInterestRate}
        />
      </Grid>
      {props?.creditCommitteeDiscountPoints !== null &&
      props?.creditCommitteeDiscountPoints !== undefined ? (
        <Grid
          item
          xs={12}
          m={2}
          style={{ margin: "0px 12px 12px 12px" }}
          data-testid="credit-committee-discount-points"
        >
          <span>
            {t("discountPoints")}: {props.creditCommitteeDiscountPoints}
          </span>
        </Grid>
      ) : null}
    </Grid>
  );
}
